export const hideExplorerSection = (
    sectionConfig: HeaderSectionConfig,
): HeaderSectionConfig => {
    if (sectionConfig.section.name === 'explorer') {
        return {
            ...sectionConfig,
            render: false,
        };
    }

    return sectionConfig;
};

export const showExplorerSection = (
    sectionConfig: HeaderSectionConfig,
): HeaderSectionConfig => {
    if (sectionConfig.section.name === 'explorer') {
        return {
            ...sectionConfig,
            render: true,
        };
    }

    return sectionConfig;
};
